// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"42":"css/material-design-icons","79":"css/CustomCSS","252":"css/app","505":"css/sweetalert2","896":"css/materialdesignicons"}[chunkId] + ".css";
};